module.exports = __webpack_public_path__ + "img/image 2427.fe892675.png";